import { ReduxState } from "../store";

export const selectKYC_Status = (state: ReduxState) => state.signUp.KYC_Status;
export const selectUserId = (state: ReduxState) => state.signUp.userId;
export const selectSignUpStep = (state: ReduxState) => state.signUp.signUpStep;
export const selectFetchStatus = (state: ReduxState) => state.signUp.fetchStatus;
export const selectUserEmail = (state: ReduxState) => state.signUp.userEmail;
export const selectEditMode = (state: ReduxState) => state.signUp.editMode;
export const selectPhoneNumber = (state: ReduxState) => state.signUp.phoneNumber;
export const selectEducationInfo = (state: ReduxState) => state.signUp.educationInfo;
export const selectWorkExperience = (state: ReduxState) => state.signUp.workExperience;
export const selectPersonalInfo = (state: ReduxState) => state.signUp.personalInfo;
export const selectIDPhoto = (state: ReduxState) => state.signUp.IDPhoto;
export const selectPersonalPhoto = (state: ReduxState) => state.signUp.personalPhoto;
export const selectExperties = (state: ReduxState) => state.signUp.experties;
export const selectVisaAndSalaryRange = (state: ReduxState) => state.signUp.visaAndSalaryRange;
export const selectCountries = (state: ReduxState) => state.signUp.countriesList;
export const selectStates = (state: ReduxState) => state.signUp.statesList;
export const selectCities = (state: ReduxState) => state.signUp.citiesList;
export const selectExpertsList = (state: ReduxState) => state.signUp.expertsList;
export const selectSkillsList = (state: ReduxState) => state.signUp.skillsList;
export const selectUniversities = (state: ReduxState) => state.signUp.universitiesList;
export const selectJobList = (state: ReduxState) => state.signUp.jobList;
export const selectTermsAndConditionsModal = (state: ReduxState) => state.signUp.termsAndConditionsModal;
export const selectLegalAgreement = (state: ReduxState) => state.signUp.legalAgreement;
export const selectLegalModal = (state: ReduxState) => state.signUp.legalModal;
export const selectDisablePhoneNumber = (state: ReduxState) => state.signUp.disablePhoneNumber;

export const selectSignUpSupplementaryStep = (state: ReduxState) => state.signUp.signUpSupplementaryStep;
